import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';
import { Pixall, Google } from '../../analytics/index.js';
import { getPageId } from '../../transformers/pixall/DataLayerTransformer.js';
import { isVDP } from '../../utilities/index.js';
import getInventoryOwnerById from '../../utilities/getInventoryOwnerById.js';
const ownerWebsiteClickHelper = (_ref, option) => {
  let {
    data = {},
    pixallData = {},
    googleData = {},
    dataLayer,
    state,
    isEsntial,
    disablePixall,
    isPageIdIncluded = true
  } = _ref;
  const {
    inventoryId,
    ownerId,
    par = 'v_lstg',
    ctaLocation = '',
    ecommLink = false,
    label = '',
    clickType,
    valueEventCode = '0AAD'
  } = data;
  let {
    placement
  } = data;
  const {
    brand
  } = state;

  // Backwards compatibility for ctaLocation
  // Please use placement for new implementations
  if (ctaLocation && !placement) {
    placement = ctaLocation;
  }
  const owner = _get(state, `owners.${ownerId}`, {});
  const pageName = _get(dataLayer, 'page.pageName', '');
  const pageId = getPageId(dataLayer);
  const inventory = getInventoryOwnerById(state, inventoryId);
  const prefix = _kebabCase(label);
  const cdl = {
    eventProperties: {
      event: {
        valueEventCode
      }
    }
  };
  const eventSource = 'dealership';
  let {
    cmp
  } = data;
  let {
    eventResult
  } = googleData;
  let ctaPlacement = 'sticky-header';
  let queryZip = _get(dataLayer, 'user.zipCode', '');

  // FYD elot should not fall back to query
  if (pageName !== 'fyd_srl') {
    if (!queryZip) {
      queryZip = _get(state, 'query.zip', '');
    }
  }
  switch (placement) {
    case 'primary-vdp-cta':
      ctaPlacement = 'inline';
      break;
    case 'dealer-detail':
      ctaPlacement = 'dealer-card';
      break;
    default:
      break;
  }
  let pixallLabel = `Click to Dealer Site - ${cmp}${isPageIdIncluded ? ` - ${pageId}` : ''}`;
  if (ecommLink && !isEsntial) {
    eventResult = `sitelink::ecomm-deeplink::${placement}`;
    cmp = 'exp_pymt_ecomm_dplnk';
    if (prefix === 'calculate-your-payment') {
      eventResult = `sitelink::open::calculate-payment::${ctaPlacement}`;
      cmp = `cta::open::calculate-payment::${ctaPlacement}`;
      pixallLabel = `Click to Dealer Site - ${cmp}`;
    } else if (prefix === 'explore-payment-options' && ctaPlacement !== 'dealer-card') {
      eventResult = `sitelink::ecomm-deeplink::explore-payment-details::${ctaPlacement}`;
      cmp = brand === 'kbb' ? `exp_pymt_ecomm_dplnk-${pageId}-${ctaPlacement}` : `exp_pymt_ecomm_dplnk-${ctaPlacement}`;
      pixallLabel = `Click to Dealer Site - ${cmp}`;
    } else if (prefix === 'buy-now') {
      eventResult = ctaPlacement === 'dealer-card' ? `sitelink::ecomm-deeplink::${prefix}::${ctaPlacement}` : `sitelink::ecomm-deeplink::${prefix}::${placement}`;
      cmp = ctaPlacement === 'dealer-card' ? `sitelink::ecomm-deeplink::${prefix}::${ctaPlacement}` : `${prefix}_ecomm_dplnk`;
      pixallLabel = ctaPlacement === 'dealer-card' ? `Click to Dealer Site - ${cmp}` : `Click to Dealer Site - ${cmp} - ${pageId}`;
    } else {
      pixallLabel = `Click to Dealer Site - ${cmp}${isPageIdIncluded ? ` - ${pageId}` : ''}`;
    }
  }
  if (!disablePixall) {
    Pixall.sendClickEvent({
      pixallData: {
        ...pixallData,
        clickTypeToListingType: isVDP(dataLayer) || clickType === 'recommendations'
      },
      label: pixallLabel,
      eventSource,
      feature: 'Drive the 5',
      inventory,
      owner,
      par,
      zipCode: queryZip,
      hasListingType: pixallData.hasListingType,
      cdl
    }, dataLayer, option);
  }
  if (Object.keys(googleData).length > 0) {
    Google.sendClickEvent({
      ...googleData,
      eventResult
    }, option);
  }
  return {
    cmp
  };
};
export default ownerWebsiteClickHelper;